import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'

import { languageController } from '../../../../controllers/language/languageController'
import formLang from '../../../../controllers/language/shared/form'

import Input from '../../../1_Atoms/Forms/Input/Input'
import Textarea from '../../../1_Atoms/Forms/Textarea/Textarea';
import Select from '../../../1_Atoms/Forms/Select/Select'
import { useForm } from '../../../../hooks/useForm'
import Button from '../../../1_Atoms/Button/Button'
import { Svg } from '../../../1_Atoms/Svg/Svg'
import Form from '../../../2_Molecules/Form/Form'
import FormGroup from '../../../2_Molecules/FormGroup/FormGroup'

function YourInformationStep_TiE({
  language,
  handleNextStep,
}) {
  const purchaseDateOptions = formLang.select.expectedPurchaseOptions;

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    phone:'',
    preferredContact:'',
    message:'',
    purchaseDate: purchaseDateOptions[0][language]
  }

  const [phoneValue, setPhoneValue] = useState('')
  const [validations, setValidations] = useState({
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    phone:['phone'],
    purchaseDate: ['required'],
  })

  const { handleSubmit, handleChange, data, errors } = useForm({
    initState,
    validations,
    onSubmit: () => {
      handleNextStep({ userInformation: data })
    },
  })

  const { firstname, lastname, email, purchaseDate, phone, preferredContact, message } = data;

  useEffect(() => {
    setValidations(prevValidations => {
      const newValidations = { ...prevValidations }; // Create a new object copy
      if (phoneValue.length > 9) {
        // Add 'required' rule to preferredContact
        newValidations.preferredContact = ['required'];
      } else {
        // Remove preferredContact rule
        if (newValidations.preferredContact) {
          delete newValidations.preferredContact;
        }
      }
      return newValidations;
    });
  }, [phoneValue])

  return (
    <div className="mz-your-information-step-tie">
      <div className="mz-container">
        <div className="grid-inner-content">
          <h5 className="mz-your-information-step-tie__title">{languageController.getCopy('tradeInEstimator', 'step3Title')}</h5>
          <Form
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            requiredFieldsHelperText={true}
          >
            <FormGroup md={2}>
              <Input
                type="text"
                name="firstname"
                label={languageController.getFormCopy('label', 'firstname')}
                value={firstname}
                isRequired={true}
                errorMessage={errors.firstname}
                onChange={handleChange}
                maxLength={50}
              />
              <Input
                type="text"
                name="lastname"
                label={languageController.getFormCopy('label', 'lastname')}
                value={lastname}
                isRequired={true}
                errorMessage={errors.lastname}
                onChange={handleChange}
                maxLength={50}
              />
            </FormGroup>
            <Input
              type="email"
              name="email"
              label={languageController.getFormCopy('label', 'email')}
              value={email}
              isRequired={true}
              errorMessage={errors.email}
              onChange={handleChange}
              maxLength={500}
            />
            <FormGroup md={2}>
              <Input
                  type="text"
                  name="phone"
                  label={languageController.getFormCopy('label', 'phone')}
                  id="contact-phone"
                  value={phone}
                  isRequired={false}
                  errorMessage={errors.phone}
                  onChange={(e)=>{
                    handleChange(e)
                    if(phoneValue != e.target.value)setPhoneValue(e.target.value.replace(/\D/g, ''))
                  }}
                  maxLength={14}
                />
              
                {phoneValue.length > 9 &&
                  
                    <Select
                      name="preferredContact"
                      label={languageController.getFormCopy('label', 'preferredContact')}
                      id="contact-preferredContact"
                      value={preferredContact}
                      isRequired={true}
                      errorMessage={errors.preferredContact}
                      onChange={handleChange}
                      placeholder={languageController.getFormCopy('placeholder', 'preferredContact')}
                      options={formLang.select.preferredContact.map(subject => ({
                        value: subject[language],
                        label: subject[language],
                      }))}
                    />
                  
                  }
                </FormGroup>
                <Textarea
                    name="message"
                    label={languageController.getFormCopy('label', 'message')}
                    id="contact-message"
                    value={message}
                    isRequired={false}
                    errorMessage={errors.message}
                    onChange={handleChange}
                    maxLength={1999}
                    rows={5}
                  />
            <Select
              name="purchaseDate"
              label={languageController.getFormCopy('label', 'expectedPurchaseDate')}
              value={purchaseDate}
              isRequired={true}
              errorMessage={errors.purchaseDate}
              onChange={handleChange}
              options={purchaseDateOptions.map(option => ({
                value: option[language],
                label: option[language],
              }))}
            />
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={languageController.getCopy('global', 'continue')}
              buttonIcon={<Svg type="chevron_small" size={0.8} colour="white" style={{ top: '1px' }} />}
              buttonIconPosition="right"
              disabled={(!firstname || !lastname || !email)}
            />
          </Form>
        </div>
      </div>
    </div>
  )
}

YourInformationStep_TiE.propTypes = {
  language: PropTypes.string.isRequired,
  handleNextStep: PropTypes.func.isRequired
}

export default YourInformationStep_TiE

